import { render } from "./ServiceRoomsModule.vue?vue&type=template&id=4f0d7b16&scoped=true"
import script from "./ServiceRoomsModule.vue?vue&type=script&lang=js"
export * from "./ServiceRoomsModule.vue?vue&type=script&lang=js"

import "./ServiceRoomsModule.vue?vue&type=style&index=0&id=4f0d7b16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f0d7b16"

export default script